import React, { Suspense, useMemo, useState, useEffect } from "react";

interface ArtworkImageLoaderProps {
  artwork: {
    uuid: string;
    media: {
      responsive_image_urls: string[];
    }[];
  };
  className?: string;
  imageWidth?: number;
  lowResImageOnly?: boolean;
}

const ArtworkImageLoader: React.FC<ArtworkImageLoaderProps> = ({
  artwork,
  className = "",
  lowResImageOnly = false,
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const imageData = useMemo(
    () => artwork.media[0].responsive_image_urls,
    [artwork],
  );
  let highResImage = imageData[0];
  const lowResImage = imageData[imageData.length - 1];

  if (lowResImageOnly) {
    highResImage = lowResImage;
  }

  useEffect(() => {
    const img = new Image();
    img.src = highResImage;
    img.onload = () => setIsLoaded(true);
  }, [highResImage]);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div
        className={`w-full h-full flex items-center justify-center overflow-hidden ${className}`}
      >
        <img
          src={isLoaded ? highResImage : lowResImage}
          alt=""
          className={`select-none w-auto max-h-full transition-filter duration-200 ${
            isLoaded ? "filter-none" : "filter blur-sm"
          }`}
        />
      </div>
    </Suspense>
  );
};

export default ArtworkImageLoader;
